<template>

  <v-select
      prepend-icon="chrome_reader_mode"
      :items="getItems"
      v-model="item"
      :label="$t('delivery.mode.mode')"
      :loading="loading"
      :error="hasInputErrors('state')"
      :error-messages="getInputErrors('state')"
      color="secondary"
      item-color="secondary"
      :clearable="clearable"
      :multiple="multiple"
      :chips="chips"
      :solo="solo"
  ></v-select>

</template>

<script>

import {InputErrorsByProps, RequiredRule} from '@dracul/common-frontend'


export default {
  name: "OrderModeCombobox",
  mixins: [InputErrorsByProps, RequiredRule],
  props: {
    value: {type: [String, Array]},
    clearable: {type: Boolean, default: false},
    multiple: {type: Boolean, default: false},
    solo: {type: Boolean, default: false},
    chips: {type: Boolean, default: false}
  },
  data() {
    return {
      items: ['TAKE_AWAY', 'DELIVERY', 'SALON'],
      loading: false
    }
  },
  computed: {
    item: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    getItems() {
      return this.items
    }
  },
  methods: {
    validate() {
      return this.$refs.form.validate()
    }
  }
}
</script>

<style scoped>

</style>

